// extracted by mini-css-extract-plugin
export default {"header":"Header_header__k3XGi","headerLogo":"Header_headerLogo__tpKhp","headerNav":"Header_headerNav__FJM-P","navLink":"Header_navLink__jzjoh","active":"Header_active__nJPPr"};